import cx from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { Fragment, useCallback, useState } from 'react';

import useLinkProps from '../../../../../hooks/use-link-props';
import { ListSeparator } from '../../../../ui/v2/categories/navigation/default-list';
import generateLink from '../../../../ui/categories/navigation/generate-link';
import MenuLink from '../../../../ui/links/menu';
import PartNameWithStock from '../../../../ui/v2/categories/common/part-name-with-stock';
import BPModal from '../../../../ui/modal';
import PageTitleSEO from '../../../../ui/v2/typography/page-title';
import AlertForm from '../../../../modules/v2/create-part-alert/form';
import useLoggedUser from '../../../../../hooks/use-logged-user';

const Item = ({ group_id, group, vehicle, category, regex }) => {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const getLink = useLinkProps();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState({});
  const user = useLoggedUser();

  const partname = useCallback(
    (name: string) => {
      return name.split(regex).map((value, index, original) => {
        if (index < original.length - 1) {
          return (
            <Fragment key={value + index}>
              {value}
              <span key={value + index} className="font-bold text-brand-100">
                {name.match(regex)?.[0]}
              </span>
            </Fragment>
          );
        }

        return <Fragment key={value + index}>{value}</Fragment>;
      });
    },
    [regex]
  );

  return (
    <>
      {parseInt(group_id, 10) > 0 && (
        <ListSeparator
          id={parseInt(group_id, 10)}
          inColumns={true}
          t={t}
          locale={locale}
        />
      )}
      {group?.map(
        ({
          name,
          id,
          slug: partSlug,
          total_products: totalPartProducts,
          ...rest
        }: TPart) => (
          <li key={id}>
            {
              totalPartProducts <= 0 ?
                <MenuLink onClick={() => {
                  setSelectedInfo({
                    subCategory: name,
                    partSlug: partSlug,
                  })
                  setIsModalOpen(true);
                  return
                }}>
                  <PartNameWithStock
                    name={partname(name)}
                    slug={partSlug}
                    nameTextTag={'h3'}
                    totalStock={totalPartProducts}
                  />
                </MenuLink> : <Link
                  {...generateLink({
                    getLink,
                    slug: vehicle,
                    partSlug,
                    categorySlug: category,
                  })}
                  passHref
                  shallow
                  scroll
                  prefetch={false}
                  itemProp="subcategory"
                  legacyBehavior
                >
                  <MenuLink>
                    <PartNameWithStock
                      name={partname(name)}
                      slug={partSlug}
                      nameTextTag={'h3'}
                      totalStock={totalPartProducts}
                    />
                  </MenuLink>
                </Link>
            }

          </li>
        )
      )}
      <BPModal
        variant="container"
        showClose={true}
        title={''}
        isOverflowVisible={false}
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      >
        <>
          <div className={cx('container', 'm-auto', 'mt-6')}>
            <div className="flex flex-col gap-4">
              <PageTitleSEO
                textAlign={'left'}
                title={t('private-area:part-alerts-create.page-tile') as string}
              />
              <h3 className="text-[20px] text-left">
                {t('private-area:part-alerts-create.page-subtitle')}
              </h3>
            </div>
            {!user && (
              <div className="container mx-auto mt-6 px-4 py-4 text-center bg-brand-10">
                <p>{t('private-area:part-alerts-create.alert')}</p>
              </div>
            )}
            <AlertForm info={selectedInfo} vehicle={vehicle} />
          </div>
        </>
      </BPModal>
    </>
  );
};

export default Item;
